export default "__VITE_ASSET__B73EJXIv__"